/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportUrl
 */
export interface ReportUrl {
    /**
     * URL path to retrieve report at, this URL can be embedded directly into an html <a> tag or similar.
     * This URL path needs to be preceded by the same back office service host you used to get this response.
     * @type {string}
     * @memberof ReportUrl
     */
    urlPath: string;
}

/**
 * Check if a given object implements the ReportUrl interface.
 */
export function instanceOfReportUrl(value: object): value is ReportUrl {
    if (!('urlPath' in value) || value['urlPath'] === undefined) return false;
    return true;
}

export function ReportUrlFromJSON(json: any): ReportUrl {
    return ReportUrlFromJSONTyped(json, false);
}

export function ReportUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportUrl {
    if (json == null) {
        return json;
    }
    return {
        
        'urlPath': json['urlPath'],
    };
}

export function ReportUrlToJSON(value?: ReportUrl | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'urlPath': value['urlPath'],
    };
}

